import Link from "next/link";
import { FooterLink } from "@/app/lib/features/footer/footer.types";
import { trackGeneric } from "@/app/lib/tracking/interactions";

interface FooterBottomProps {
  copyrightText: string;
  links: FooterLink[];
}

const FooterBottom = ({ copyrightText, links }: FooterBottomProps) => {
  return (
    <div className="bg-black text-white text-xs">
      <div className="container-minify min-h-11.25 flex flex-col md:flex-row items-center justify-between gap-4 py-3 sm:py-0 space-y-4 md:space-y-0">
        <div dangerouslySetInnerHTML={{ __html: copyrightText }} />
        <div className="grid grid-cols-2 md:flex items-center justify-center md:justify-start gap-2 sm:gap-4 text-center">
          {links.map((link) => (
            <Link
              key={link.title}
              href={link.url}
              onClick={() => trackGeneric(`footer_link_${link.url.replace(/\//g, "").slice(0, 30)}`, "click")}
              className="transition-all duration-300 ease-in-out hover:underline whitespace-nowrap"
            >
              {link.title}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FooterBottom;
